import 'select';
// FIXME: I think this is supposed to keep the nav button for the section you are on styled as active but don't think it actually works
export default Backbone.Model.extend({
  initialize: function () {
    var that = this;
    require(["select"], function () {
      Backbone.Select.Me.applyTo(that);
    });
  }
});